"use client";
import React, { createContext, useContext, useState, useEffect } from "react";

const ShoppingCartContext = createContext();

export const ShoppingCartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartItemsCoupons, setCartItemsCoupons] = useState([]);

  //========== checking any changes happend in cartPaymentInfo from the localstorage =========//
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "cartPaymentInfo") {
        const updatedCartPaymentInfo = JSON.parse(event.newValue);
        updateCartData(updatedCartPaymentInfo);
      }
      if (event.key === "itemsCoupons") {
        const updatedItemsCoupons = JSON.parse(event.newValue);
        updateItemsCoupons(updatedItemsCoupons);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const updateCartData = (cartPaymentInfo) => {
    let empty = [];
    if (cartPaymentInfo?.length > 0) {
      setCartItems(cartPaymentInfo);
    } else {
      setCartItems(empty);
    }
  };

  const updateItemsCoupons = (itemsCoupons) => {
    let empty = [];
    if (itemsCoupons?.length > 0) {
      setCartItemsCoupons(itemsCoupons);
    } else {
      setCartItemsCoupons(empty);
    }
  };
  //========== checking any changes happend in cartPaymentInfo from the localstorage =========//

  useEffect(() => {
    if (typeof window !== "undefined") {
      const localData = window.localStorage.getItem("cartPaymentInfo")
        ? window.localStorage.getItem("cartPaymentInfo")
        : "[]";
      const localDataItemsCoupons = window.localStorage.getItem("itemsCoupons")
        ? window.localStorage.getItem("itemsCoupons")
        : "[]";
      if (localData) {
        setCartItems(JSON.parse(localData));
      }

      if (localDataItemsCoupons) {
        setCartItemsCoupons(JSON.parse(localDataItemsCoupons));
      }
    }
  }, []);

  return (
    <ShoppingCartContext.Provider
      value={{
        cartItems,
        setCartItems,
        cartItemsCoupons,
        setCartItemsCoupons,
      }}
    >
      {children}
    </ShoppingCartContext.Provider>
  );
};

export const useShoppingCart = () => useContext(ShoppingCartContext);
